import { Icon, type IconName } from './icon';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
  icon?: IconName;
}

interface SegmentedProps<T extends string> {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  ariaLabel?: string;
}

export function Segmented<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
}: SegmentedProps<T>) {
  const idx = Math.max(
    0,
    options.findIndex((o) => o.value === value)
  );
  const n = options.length;
  return (
    <div className="wb-seg" role="tablist" aria-label={ariaLabel} style={{ width: '100%' }}>
      <div
        className="wb-seg-thumb"
        style={{
          width: `calc((100% - 8px) / ${n})`,
          left: 4,
          transform: `translateX(${idx * 100}%)`,
        }}
      />
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.icon && <Icon name={o.icon} size={17} />}
          {o.label}
        </button>
      ))}
    </div>
  );
}
